/**
 * The journal slice.
 *
 * **This is not a face.** `entries/` is one domain with one production face, `src/entries/index.ts`
 * (ADR 0014:114-116): the four content slices and the registry sit inside it and reach each other
 * freely, because a seam's adapters are the inside of one module rather than four modules facing
 * each other. This index exists so a sibling slice and the domain face name one path per slice
 * rather than seven; a file outside `src/entries/` names neither.
 */

export type { JournalEntry, JournalMeta, PromptCategory } from './meta'
export { isJournalEntry } from './guard'

export type { JournalDraft } from './write-spec'
export {
  useCreateJournal,
  useUpdateJournal,
  useDeleteJournal,
} from './write-spec'

export { selectJournalToday, useJournalToday } from './select-today'

export type { ReflectionPrompt } from './prompts'
export {
  REFLECTION_PROMPTS,
  RESTART_PROMPTS,
  getPromptsByCategory,
  getPromptById,
} from './prompts'

export { JournalRow } from './row'
export { JournalView } from './view'
export { PromptBadge } from './prompt-badge'
export { JournalPrompt } from './journal-prompt'
